import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=36afe1a8"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Gallery.vue?vue&type=style&index=0&id=36afe1a8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "fbd40cae"
  
)

export default component.exports